import { Combobox } from '@monorepo/shared/componentsV2/Combobox';
import { SelectableOption } from '@monorepo/shared/types/SelectableOption';
import React, { useCallback } from 'react';
import { useForm, Field } from 'react-final-form';
import {
  emailValidator,
  hasPlaceholderName,
  MAX_RENDERED_EMAIL_OPTIONS,
} from './inviteUserUtils';

interface EmailFieldProps {
  options: SelectableOption[];
  orgUsersByEmail: Map<string, { name: string; email: string }>;
  isLoading: boolean;
}

export function InviteUserEmailField({
  options,
  orgUsersByEmail,
  isLoading,
}: EmailFieldProps) {
  const form = useForm();

  const applyEmailChange = useCallback(
    (email?: string) => {
      form.change('email', email);
      const trimmed = (email ?? '').trim().toLowerCase();
      const matchingUser = trimmed ? orgUsersByEmail.get(trimmed) : undefined;
      form.change(
        'name',
        matchingUser && !hasPlaceholderName(matchingUser.name)
          ? matchingUser.name
          : '',
      );
    },
    [form, orgUsersByEmail],
  );

  return (
    <Field<string> name="email" validate={emailValidator}>
      {({ input, meta }) => {
        const hasError = !!meta.error && (meta.touched || meta.modified);
        const errorText =
          hasError && typeof meta.error === 'string' ? meta.error : undefined;

        return (
          <Combobox
            allowCustomValue
            error={hasError}
            errorText={errorText}
            isLoading={isLoading}
            label="Email"
            maxRenderedOptions={MAX_RENDERED_EMAIL_OPTIONS}
            name="email"
            onChange={(event) => applyEmailChange(event.target.value)}
            options={options}
            placeholder="Select an existing user or enter a new email."
            required
            value={input.value}
          />
        );
      }}
    </Field>
  );
}
